import { getPersistStorage } from 'common-react/utils/storage/persist-storage';
import { createAlertSlice } from 'store/alert';
import { createAvailabilitySlice } from 'store/availability';
import { createCompanySiteSlice } from 'store/company-site';
import { createOperationsSlice } from 'store/operations';
import { createOptimisationSlice } from 'store/optimisation';
import { AppState } from 'store/types';
import { createUserSlice } from 'store/user';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { createWithEqualityFn as create } from 'zustand/traditional';

const DONT_PERSIST = new Set([
  'currentDate',
  'companyModalOpen',
  'siteModalOpen',
  'mobileCompanySiteDrawerOpen',
  'mobileCalendarOpen',
  'mobileProfileOpen',
]);

// See docs /DOCS/zustand.md
export const useStore = create<AppState>()(
  devtools(
    persist(
      (...a) => ({
        ...createCompanySiteSlice(...a),
        ...createOptimisationSlice(...a),
        ...createOperationsSlice(...a),
        ...createAvailabilitySlice(...a),
        ...createUserSlice(...a),
        ...createAlertSlice(...a),
      }),
      {
        name: 'ui-state',
        storage: createJSONStorage(getPersistStorage),
        partialize: (state) =>
          Object.fromEntries(
            Object.entries(state).filter(([key]) => !DONT_PERSIST.has(key)),
          ),
      },
    ),
    { name: 'shell-pluto' },
  ),
);
